import React, { useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Button,
  Modal,
  Tab,
  Nav,
  Dropdown,
} from "react-bootstrap";
import {
  DataTable,
  DataTableBody,
  DataTableHead,
  DataTablePagination,
} from "../../../Common/DataTable";
import { useDispatch, useSelector } from "react-redux";
import {
  getRoleList,
  deleteRole,
  rowSorting,
  updateRole,
} from "../../../store/actions";
import Filters from "./Filters";
import { toast } from "react-toastify";
import { DragDropContext, Droppable } from "react-beautiful-dnd";

const columnData = [
  { id: "_id", align: false, disablePadding: true, label: "#", order: 1 },
  {
    id: "name",
    align: false,
    disablePadding: true,
    label: "Name",
    title: "Name",
    order: 1,
  },
  {
    id: "status",
    numeric: false,
    disablePadding: false,
    label: "Status",
    title: "status",
    type: "statustag",
    order: 1,
  },
  {
    id: "action",
    align: true,
    disablePadding: false,
    title: "action",
    label: "Action",
  },
];

const RoleIndex = () => {
  const dispatch = useDispatch();

  const [deleteShow, deleteSetShow] = useState(false);
  const [tabs, setTabs] = useState("all");
  const [filter, setFilter] = useState("");
  const [state, setState] = useState({
    orderBy: "sort_index",
    order: "asc",
    page: 0,
    limit: 10,
    searchBy: "name",
    search: "",
  });

  const [Delete, setDelete] = useState({
    open: false,
    dumpId: "",
  });

  const [dragUsers, setDragUsers] = useState("");
  const userData = useSelector((s) => s?.Signatures?.roles?.data);
  const totalCount = useSelector((s) => s?.Signatures?.roles?.total_count);
  const loading = useSelector((s) => s?.Signatures?.loading);

  useEffect(() => {
    if (userData) {
      setDragUsers(userData);
    }
  }, [userData]);

  const getTableRecords = () => {
    let body = {
      orderBy: state.orderBy,
      order: state.order,
      page: state.page,
      limit: state.limit,
      search: filter,
      searchBy: state.searchBy,
    };

    dispatch(getRoleList(body));
  };

  useEffect(() => {
    getTableRecords(state.order, state.orderBy);
  }, [state]);

  const handleStatus = (e) => {
    e.preventDefault();
    const { value } = e.target;
    setState((pre) => ({
      ...pre,
      status: value,
    }));
  };

  const resetFilter = () => {
    setState((pre) => ({
      ...pre,
      search: "",
    }));
    setFilter("");
  };

  const handleChangePage = (event, page) => {
    setState((pre) => ({
      ...pre,
      page: page,
    }));
    // getTableRecords(state.order, state.orderBy);
  };

  const handleSearchChange = (e) => {
    const { name, value } = e.target;
    setFilter(value);
  };

  const filterdata = (e) => {
    e.preventDefault();
    getTableRecords(1, state.orderBy);
  };

  const DeletePopup = (state, id) => {
    setDelete((pre) => ({
      ...pre,
      open: state,
      dumpId: id,
    }));
  };

  const StatusPopup = (state, data) => {
    const callBack = (res) => {
      if (res.data) {
        toast.success("Updated Successfully!");
        dispatch(
          getRoleList({
            orderBy: "id",
            order: "asc",
            page: 0,
            limit: 10,
            searchBy: "name",
            search: "",
          })
        );
      }
    };
    dispatch(
      updateRole(
        {
          userId: data.id,
          name: data.name,
          permissions: data.permissions,
          status: data.status == "1" ? "0" : "1",
        },
        callBack
      )
    );
  };

  const handleDelete = () => {
    const callBack = (response) => {
      if (response.data) {
        toast.success(response.message);
        setDelete(false);
        dispatch(
          getRoleList({
            orderBy: "id",
            order: "asc",
            page: 0,
            limit: 10,
            searchBy: "name",
            search: "",
          })
        );
      } else {
        setDelete(false);
      }
    };
    dispatch(deleteRole({ userId: JSON.stringify(Delete.dumpId) }, callBack));
  };

  const handleRequestSort = (data) => {
    if (data.key !== "action") {
      let NewColoumns = state.columns.map((key, index) => {
        if (key.id !== data.key) {
          return { ...key, order: 1 };
        } else {
          return { ...key, order: data.order };
        }
      });
      setState(
        {
          loading: true,
          columns: NewColoumns,
          orderBy: data.key,
          order: data.order,
          rowsPerPage: 10,
          page: 0,
        },
        () => getTableRecords(data.order, data.key)
      );
    }
  };

  const handleDragEnd = (e) => {
    if (!e.destination) return;
    let tempData = Array.from(dragUsers);
    let [source_data] = tempData.splice(e.source.index, 1);
    tempData.splice(e.destination.index, 0, source_data);
    setDragUsers(tempData);

    let body = {
      id: e?.draggableId,
      current_index: JSON.stringify(e?.source?.index + 1),
      destination_index: JSON.stringify(e?.destination?.index + 1),
      action_on: "role",
    };
    dispatch(rowSorting(body));
  };

  const handleDeletePopup = (state, id) => {
    console.log("state, id==>>", state, id);

    setDelete((pre) => ({
      ...pre,
      open: state,
      dumpId: id,
    }));
  };

  return (
    <>
      <Modal
        show={Delete.open}
        onHide={() => {
          setDelete(false);
        }}
        className="deleteAdd-pop delete-pop"
        centered
      >
        <Modal.Body>
          <div className="text-center py-3">
            <div className="icn my-3">
              <svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M256,0C114.497,0,0,114.507,0,256c0,141.503,114.507,256,256,256c141.503,0,256-114.507,256-256    C512,114.497,397.493,0,256,0z M256,472c-119.393,0-216-96.615-216-216c0-119.393,96.615-216,216-216    c119.393,0,216,96.615,216,216C472,375.393,375.385,472,256,472z"
                  fill="#f8c886"
                ></path>
                <path
                  d="M256,128.877c-11.046,0-20,8.954-20,20V277.67c0,11.046,8.954,20,20,20s20-8.954,20-20V148.877    C276,137.831,267.046,128.877,256,128.877z"
                  fill="#f8c886"
                ></path>
                <circle cx="256" cy="349.16" r="27" fill="#f8c886"></circle>{" "}
              </svg>
            </div>
            <h2 className="pop-head m-0 pb-2">Are you Sure?</h2>
            <div className="btn-wrap my-2 d-flex align-items-center justify-content-center mt-3">
              <div className="pe-2 w-50">
                <Button
                  className="btn-2 w-100 d-flex align-items-center justify-content-center"
                  onClick={() => {
                    setDelete(false);
                  }}
                >
                  No Cancel!
                </Button>
              </div>
              <div className="pe-2 w-50">
                <Button
                  onClick={handleDelete}
                  className="w-100 d-flex align-items-center justify-content-center"
                >
                  Yes, Delete it
                </Button>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
      <section className="dashboard py-2">
        <Container>
          <Row>
            <Col lg="12" className="my-2">
              <div className="top mb-2">
                <h4 className="dashboard-head m-0">Roles & Permissions</h4>
              </div>
            </Col>
            <Col lg="12" className="my-2">
              <div className="bg-white px-4 py-3">
                <Filters
                  status={state.status}
                  columns={state.columns}
                  filter={filter}
                  handleStatus={handleStatus}
                  handleSearchChange={handleSearchChange}
                  filterdata={filterdata}
                  resetFilter={resetFilter}
                />
              </div>
              <Tab.Container id="left-tabs-example" defaultActiveKey={tabs}>
                <div className="bg-white px-4 py-3 card-box">
                  <Tab.Content>
                    <Tab.Pane eventKey={tabs}>
                      <div className="table-responsive py-3">
                        <DragDropContext onDragEnd={handleDragEnd}>
                          <DataTable className="">
                            <DataTableHead
                              columns={columnData}
                              orderBy={state.orderBy}
                              sort={handleRequestSort}
                            />
                            <Droppable droppableId="droppable-1">
                              {(provider) => (
                                <DataTableBody
                                  loading={loading}
                                  column={columnData}
                                  data={dragUsers}
                                  page={state.page}
                                  rowsPerPage={state.limit}
                                  innerRef={provider.innerRef}
                                  dropProp={provider.droppableProps}
                                  actionBtn={[
                                    {
                                      label: "Edit",
                                      icon: "",
                                      link: "/role-permissions/edit",
                                    },
                                    {
                                      label: "Delete",
                                      icon: "",
                                      action: handleDeletePopup,
                                    },
                                    {
                                      label: "Active",
                                      icon: "",
                                      action: StatusPopup,
                                    },
                                  ]}
                                />
                              )}
                            </Droppable>
                          </DataTable>
                        </DragDropContext>
                        <div className="custom-pagination d-flex align-items-center w-100 justify-content-end">
                          <div className="main-pagination-drop d-flex gap-2 align-items-center">
                            <h6 className="row-per-page-heading m-0">
                              Rows per page:
                            </h6>
                            <Dropdown>
                              <Dropdown.Toggle
                                variant="success"
                                id="dropdown-basic"
                              >
                                {state.limit}
                              </Dropdown.Toggle>

                              <Dropdown.Menu>
                                <Dropdown.Item
                                  onClick={() =>
                                    setState((pre) => ({ ...pre, limit: 10 }))
                                  }
                                >
                                  10
                                </Dropdown.Item>
                                <Dropdown.Item
                                  onClick={() =>
                                    setState((pre) => ({ ...pre, limit: 25 }))
                                  }
                                >
                                  25
                                </Dropdown.Item>
                                <Dropdown.Item
                                  onClick={() =>
                                    setState((pre) => ({ ...pre, limit: 50 }))
                                  }
                                >
                                  50
                                </Dropdown.Item>
                                <Dropdown.Item
                                  onClick={() =>
                                    setState((pre) => ({ ...pre, limit: 100 }))
                                  }
                                >
                                  100
                                </Dropdown.Item>
                              </Dropdown.Menu>
                            </Dropdown>
                          </div>
                          {dragUsers?.length > 0 && (
                            <DataTablePagination
                              count={totalCount}
                              rowsPerPage={state.limit}
                              page={state.page}
                              onPageChange={handleChangePage}
                              rowsPerPageOptions={[]}
                            />
                          )}
                        </div>
                      </div>
                    </Tab.Pane>
                  </Tab.Content>
                </div>
              </Tab.Container>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default RoleIndex;
